export enum SectionNameEnum {
    HeroSection = 'hero',
    FeaturedAccommodationsSection = 'featured_accommodations',
    FeaturedCountriesSection = 'featured_countries',
    DestinationSuggestionsSection = 'destination_suggestions',
    PopularTravelDestinations = 'popular_travel_destinations',
}
